$(document).ready(function () {
    $('.product-single__thumbnails').slick({
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 1
    });
})
// BOOT SIZER xoxo @littlered
$('.js-calculate').click(function () {
    $('.size-error').html('');
    $('#js-cbc-left').html('');
    $('#js-cbc-right').html('');
    let widthL = $('#widthL').val();
    let lengthL = $('#lengthL').val();
    let width = $('#width').val();
    let length = $('#length').val();
    if ($.isNumeric(width) && $.isNumeric(length)) {
        let size = calculateCBCSize(length, width);
        let size2 = size;
        let sizeL = calculateCBCSize(lengthL, widthL);
        if  (size  !== sizeL ){
            console.log("two sizes");
            if(sizeL.toString().includes('W')){
                size2 = sizeL;
                console.log(size2);
            }
        }
        let sizeLT = size2.toString().replace('W', '');
        // let  sizeLLT = sizeL.toString().replace('W', '');
        //let sizeAnswer = "Right:" + size + " Left:" + sizeL;
        $('#js-cbc-left').html(size2);
        // $('#js-cbc-right').html(size);
        $('#js-cbc-left-long').html(sizeLT);
        // $('#js-cbc-right-long').html(sizeLT);
    } else {
        $('.size-error').html('Please enter only numeric values.');
    }

    function inRange(n, start, end) {
        if (n >= start && n <= end) return true;
        else return false;
    }

    function calculateCBCSize(length, width) {
        let fatFoot =
            "Please contact us about a custom fit boot.";
        let skinnyFoot =
            "Please contact us about a custom fit boot.";

        // SIZE 29
        if (inRange(length, 181, 186)) {
            if (width < 0) {
                return skinnyFoot;
            } else if (inRange(width, 0, 72)) {
                return 29;
            } else if (inRange(width, 73,80)) {
                return "29W";
            } else {
                return fatFoot;
            }
        }
        // SIZE 30
        else if (inRange(length, 187, 193)) {
            if (width < 0) {
                return skinnyFoot;
            } else if (inRange(width, 0, 75)) {
                return 30;
            } else if (inRange(width, 76,82)) {
                return "30W";
            } else {
                return fatFoot;
            }
        }
        // SIZE 31
        else if (inRange(length, 194,200)) {
            if (width < 0) {
                return skinnyFoot;
            } else if (inRange(width, 0, 77)) {
                return 31;
            } else if (inRange(width, 78,84)) {
                return "31W";
            } else {
                return fatFoot;
            }
        }
        // SIZE 32
        else if (inRange(length, 201,206)) {
            if (width < 0) {
                return skinnyFoot;
            } else if (inRange(width, 0, 79)) {
                return 32;
            } else if (inRange(width, 80,86)) {
                return "32W";
            } else {
                return fatFoot;
            }
        }
        // SIZE 33
        else if (inRange(length, 207,214)) {
            if (width < 0) {
                return skinnyFoot;
            } else if (inRange(width, 0, 81)) {
                return 33;
            } else if (inRange(width, 82,88)) {
                return "33W";
            } else {
                return fatFoot;
            }
        }
        // SIZE 34
        else if (inRange(length, 215,220)) {
            if (width < 0) {
                return skinnyFoot;
            } else if (inRange(width, 0, 83)) {
                return 34;
            } else if (inRange(width, 84,90)) {
                return "34W";
            } else {
                return fatFoot;
            }
        }
        // SIZE 35
        else if (inRange(length, 221,227)) {
            if (width < 0) {
                return skinnyFoot;
            } else if (inRange(width, 0, 85)) {
                return 35;
            } else if (inRange(width, 86,92)) {
                return "35W";
            } else {
                return fatFoot;
            }
        }
        // SIZE 36
        else if (inRange(length, 228,233)) {
            if (width < 0) {
                return skinnyFoot;
            } else if (inRange(width, 0, 87)) {
                return 36;
            } else if (inRange(width, 88,95)) {
                return "36W";
            } else {
                return fatFoot;
            }
        }
        // SIZE 37
        else if (inRange(length, 234,240)) {
            if (width < 0) {
                return skinnyFoot;
            } else if (inRange(width, 0, 89)) {
                return 37;
            } else if (inRange(width, 90,97)) {
                return "37W";
            } else {
                return fatFoot;
            }
        }
        // SIZE 38
        else if (inRange(length, 241,247)) {
            if (width < 0) {
                return skinnyFoot;
            } else if (inRange(width, 0, 91)) {
                return 38;
            } else if (inRange(width, 92,99)) {
                return "38W";
            } else {
                return fatFoot;
            }
        }
        // SIZE 39
        else if (inRange(length, 248,253)) {
            if (width < 0) {
                return skinnyFoot;
            } else if (inRange(width, 0, 94)) {
                return 39;
            } else if (inRange(width, 95,101)) {
                return "39W";
            } else {
                return fatFoot;
            }
        }
        // SIZE 40
        else if (inRange(length, 254,260)) {
            if (width < 0) {
                return skinnyFoot;
            } else if (inRange(width, 0, 96)) {
                return 40;
            } else if (inRange(width, 97, 103)) {
                return "40W";
            } else {
                return fatFoot;
            }
        }
        // SIZE 41
        else if (inRange(length, 261,267)) {
            if (width < 0) {
                return skinnyFoot;
            } else if (inRange(width, 0, 98)) {
                return 41;
            } else if (inRange(width, 99,105)) {
                return "41W";
            } else {
                return fatFoot;
            }
        }

        // SIZE 42
        else if (inRange(length, 268,273)) {
            if (width < 0) {
                return skinnyFoot;
            } else if (inRange(width, 0, 100)) {
                return 42;
            } else if (inRange(width, 101,107)) {
                return "42W";
            } else {
                return fatFoot;
            }
        }
        // SIZE 43
        else if (inRange(length, 274,280)) {
            if (width < 0) {
                return skinnyFoot;
            } else if (inRange(width, 0, 102)) {
                return 43;
            } else if (inRange(width, 103,109)) {
                return "43W";
            } else {
                return fatFoot;
            }
        }
        // SIZE 44
        else if (inRange(length, 281,287)) {
            if (width < 0) {
                return skinnyFoot;
            } else if (inRange(width, 0, 104)) {
                return 44;
            } else if (inRange(width, 105, 111)) {
                return "44W";
            } else {
                return fatFoot;
            }
        }
        // SIZE 45
        else if (inRange(length, 288,294)) {
            if (width < 0) {
                return skinnyFoot;
            } else if (inRange(width, 0, 106)) {
                return 45;
            } else if (inRange(width, 107,114)) {
                return "45W";
            } else {
                return fatFoot;
            }
        }
        // SIZE 46
        else if (inRange(length, 295,300)) {
            if (width < 0) {
                return skinnyFoot;
            } else if (inRange(width, 0, 108)) {
                return 46;
            } else if (inRange(width, 109,116)) {
                return "46W";
            } else {
                return fatFoot;
            }
        }
        // SIZE 47
        else if (inRange(length, 301,307)) {
            if (width < 0) {
                return skinnyFoot;
            } else if (inRange(width, 0, 111)) {
                return 47;
            } else if (inRange(width, 112,118)) {
                return "47W";
            } else {
                return fatFoot;
            }
        }
        // ELSE
        else {
            return "Please contact us about a custom fit boot.";
        }

    }

});
